import React from "react";
import { Link, NavLink } from "react-router-dom";
import { MessageCircle, Radio } from "lucide-react";
import { useChat } from "../context/ChatContext";

const NavItem = ({ to, children, testId }) => (
  <NavLink
    to={to}
    end
    data-testid={testId}
    className={({ isActive }) =>
      `font-condensed uppercase tracking-widest text-sm px-3 py-2 rounded transition-colors whitespace-nowrap ${
        isActive ? "text-gold" : "text-neutral-400 hover:text-gold"
      }`
    }
  >
    {children}
  </NavLink>
);

const Navbar = () => {
  const { setDrawerOpen } = useChat();
  return (
    <header className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl bg-black/70 border-b border-gold/20">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="relative w-9 h-9 grid place-items-center rounded-sm border-gold-gradient">
            <Radio className="w-4 h-4 text-gold" />
          </div>
          <div className="leading-none">
            <div className="font-display text-2xl tracking-tight text-gold-gradient">GFN SOUL</div>
            <div className="font-condensed text-[10px] tracking-[0.35em] text-neutral-400 mt-0.5">NYC · BROADCAST</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavItem to="/" testId="nav-home">Stations</NavItem>
          <NavItem to="/gfn-tv" testId="nav-gfn-tv">GFN TV</NavItem>
          <NavItem to="/on-demand" testId="nav-on-demand">On Demand</NavItem>
          <NavItem to="/schedule" testId="nav-schedule">Schedule</NavItem>
          <NavItem to="/news" testId="nav-news">News</NavItem>
          <NavItem to="/contact" testId="nav-about">About</NavItem>
          <NavItem to="/install" testId="nav-install">Get The App</NavItem>
        </nav>

        <button
          data-testid="open-chat-btn"
          onClick={() => setDrawerOpen(true)}
          className="inline-flex items-center gap-2 border border-gold/40 hover:border-gold text-gold px-4 py-2 rounded-full font-condensed uppercase tracking-widest text-xs transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          <span>Live Chat</span>
        </button>
      </div>
      {/* Mobile nav row */}
      <div className="md:hidden max-w-7xl mx-auto px-5 pb-3 flex items-center gap-1 overflow-x-auto">
        <NavItem to="/" testId="nav-home-mobile">Stations</NavItem>
        <NavItem to="/gfn-tv" testId="nav-gfn-tv-mobile">GFN TV</NavItem>
        <NavItem to="/on-demand" testId="nav-on-demand-mobile">On Demand</NavItem>
        <NavItem to="/schedule" testId="nav-schedule-mobile">Schedule</NavItem>
        <NavItem to="/news" testId="nav-news-mobile">News</NavItem>
        <NavItem to="/contact" testId="nav-about-mobile">About</NavItem>
        <NavItem to="/install" testId="nav-install-mobile">Get The App</NavItem>
      </div>
    </header>
  );
};

export default Navbar;
